<template>
<div class="ti d-flex">
<!--  <div class="d-flex-left">
    <erp-tree @node-click="nodeClick"></erp-tree>
  </div>-->
  <div class="d-flex-right">
    <div style="margin-bottom:1px">
      <el-button size="mini" @click="searchs">搜索</el-button>
      <router-link to="/stat/meterAnalysis">
        <el-button size="mini" style="color: #606266;" >能耗分析</el-button>
      </router-link>
      <el-descriptions :column="2" border size="mini" style="margin-top: 10px;" :labelStyle="{width: '100px'}" :contentStyle="{width:'43%'}">
        <el-descriptions-item  label="年份">
<!--          <el-input style="width: 100%;" placeholder="请输入内容" v-model="house"></el-input>-->
          <el-input size="mini" placeholder="请输入年份" v-model="year" clearable></el-input>
        </el-descriptions-item>
        <el-descriptions-item  label="导入人">
          <el-input size="mini" placeholder="请输入导入人" v-model="user" clearable></el-input>
        </el-descriptions-item>
<!--        <el-descriptions-item  label="收费项目">
          <el-select @change="chargeitems_son" style="width: 100%;" size="mini" v-model="chargeitemID" multiple filterable collapse-tags placeholder="收费项目" class="kuan">
            <el-option v-for="item in chargeitem" :key="item.id" :label="item.chargeItem_name" :value="item.id"></el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item :labelStyle="{color: 'red'}" label="收费标准*">
          <el-select style="width: 100%;" size="mini" v-model="chargeitemc_id" multiple filterable collapse-tags placeholder="收费标准" class="kuan">
            <el-option v-for="item in chargeitemc" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-descriptions-item>-->

        <el-descriptions-item  label="导出">
          <el-button size="mini" type="success text2" style="margin-left: 1px;" @click="excelPost">下载模板</el-button>
        </el-descriptions-item>
        <el-descriptions-item  label="导入">
          <el-button size="mini" type="success text2" style="margin-left: 1px;" @click="modals">数据导入</el-button>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <div style="margin-top: 5px;"></div>
    <el-table v-loading="loading" ref="multipleTable" :data="data" border tooltip-effect="dark" style="width: 100%" height="500">
      <el-table-column prop="id" label="ID" width="80"></el-table-column>
      <el-table-column prop="year" label="年份" width="200"></el-table-column>
      <el-table-column prop="stutes" label="状态" width="180"></el-table-column>
      <el-table-column prop="user" label="导入人" width="80"></el-table-column>
      <el-table-column prop="user_date" label="导入时间" width="180"></el-table-column>
      <el-table-column prop="remarks" label="备注" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" width="100">
        <template slot-scope="scope">
          <div style="display: flex;">
            <div style="cursor:pointer;margin-left: 5px;">
              <div @click="download(scope.row.url)" style="color: #156df1">下载</div>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pages" v-if="data">
      <Page :total="count" :page-size="pageSize" @on-change="change"  show-total />
    </div>
  </div>
    <!-- 导入-->
    <Modal
      v-model="modal"
      ok-text="确定"
      width="80%"
      :styles="{'position': 'absolute','top':'20px','left':'10%'}"
      :loading="loadingModal"
      title="数据上传"
      @on-ok="add">
      <div>
         <el-form style="height: 700px;overflow: auto;">
           <div>
             <span><span class="cdj_span">*</span>请输入年份</span>
             <div class="cdj_input">
               <el-input size="mini" placeholder="请输入年份" v-model="form.year" clearable></el-input>
             </div>
           </div>
           <div class="cdj_margin_span">
             <span>备注</span>
             <el-input class="cdj_input" type="textarea" :rows="2" placeholder="请输入内容" v-model="form.remarks"></el-input>
           </div>

          <div class="cdj_margin_span">
            <span><span class="cdj_span">*</span>上传文件</span>
            <el-upload
                style="color: #ffffff;"
                class="upload-demo cdj_input"
                :action="url"
                :before-remove="beforeRemove"
                :on-success="handleAvatarSuccess"
                accept=".xls,.xlsx"
                multiple
                :limit="1"
                :on-exceed="handleExceed"
                :file-list="fileList"
                :before-upload="beforeAvatarUpload">
                <el-button size="small" type="primary" class="texts">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">只能上传xls或xlsx文件，不能大于15m</div>
            </el-upload>
          </div>
          <div class="cdj_margin_span">
            <span style="margin-left: 15px;color: red;" v-if="loading_dade==2">加载中...</span>
            <el-table ref="multipleTable" :data="tableData" border tooltip-effect="dark" style="width: 100%" height="40vh">
              <el-table-column prop="index" label="序号" width="80"></el-table-column>
              <el-table-column prop="pindex_id" label="项目ID" width="80"></el-table-column>
              <el-table-column prop="year" label="年份" width="150" show-overflow-tooltip></el-table-column>
              <el-table-column prop="pindex_name" label="项目名称" width="200"></el-table-column>
              <el-table-column prop="monthly_amount" label="月均用量(元)"></el-table-column>
            </el-table>
            <div class="pages">
              <Page :total="total" :page-size="page" @on-change="selects" show-total />
            </div>
          </div>
         </el-form>
      </div>
   </Modal>
</div>
</template>

<script>
import imgurl from "../../../assets/js/imgurl.js"
export default {
  name: "MeterMultipleExcel",
  data () {
    return {
      date:{
        startDate:'',
        endDate:''
      },
      total:0,
      page:100,
      loading_dade:1,
      money:0,
      tableData:[],
      chargeitemc:[],
      chargeitemc_id:'',
      startDate:'',
      endDate:'',
      year:'2024',
      user:'',
      house:'',
      modal:false,
      statesModal:false,
      loading:false,
      loadingModal:true,
      chargeitem:[],
      options: [],
      count:0,
      pageSize:12,
      data: '',
      pid: '',
      text:'',
      chargeitemID:'',
      state:'',
      url:'',
      fileList:[],
      form:{
        year:'2024',
        pindex_id:'',
        name:'',
        url:'',
        remarks:'',
      },
      statesForm:{
        id:'',
        stutes:'',
        remarks:''
      },
    }
  },
  created() {
  },
  mounted(){
    var login = window.localStorage.getItem('login');
    var token = window.localStorage.getItem('token');
    this.url = this.$myhttp.defaults.baseURL + "/admin/excel?"+"login_name="+login+"&token="+token;
    //项目列表
    this.$myhttp.get('admin/common/pindex',{
      'Content-Type': 'application/json'
      }).then(backdata=>{
        this.options = backdata.data.data;
    });

    this.change(1);
  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
  methods: {
    // 查询
    selects(e){
      //console.log(36954);
      this.loading_dade = 2;
      let data = {'url':this.form.url,'year':this.form.year,'page':e}
      this.$myhttp.post('admin/MeterMultipleExcel/select',data,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          this.loading_dade = 1;
          this.tableData = backdata.data.list;
          this.total = backdata.data.count;
      },err=>{
        this.loading_dade = 1;
        this.$Message.error('请求异常!');
      });
    },
    modals(){
      this.form.year = this.year;
      this.modal = true;
    },
    //导入
    add(){
      if(this.form.year == ''){
        this.$Message.error('年份不能为空!');
        this.loadingModals();
        return false;
      }
      if(this.form.url == ''){
        this.$Message.error('上传文件不能为空!');
        this.loadingModals();
        return false;
      }
      this.$myhttp.post('admin/MeterMultipleExcel/add',this.form,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          if(backdata.data.code == 200){
            // this.form = {
            //   year:'',
            //   name:'',
            //   url:'',
            // };
            this.form.url = '';
            this.tableData = [];
            this.total = 0;
            this.money = 0;
            this.fileList = [];
            this.change(1);
            this.modal = false;
            this.$Message.success('提交成功!');
          }else{
            this.$Message.error(backdata.data.message);
          }
      });
    },
    //分页
    change(page){
      this.loading = true;
      this.$myhttp.get('admin/MeterMultipleExcel/index?page='+page+ '&year='+ this.year+"&user="+this.user,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
          if(backdata.data.code == 200){
            let data = backdata.data.data;
            this.data = data.data;
            this.count = data.count;
            this.pageSize = data.pageSize;
          }
          this.loading = false;
      });
    },
    //搜索
    searchs(){
      this.money = "--";
      this.change(1);
      this.moneys();
    },
    //时间转换
    dates() {
      if (this.startDate != null && this.startDate != "") {
        let d = this.startDate; //开始时间
        let startDate = new Date(d).getTime() / 1000;
        startDate = Number(startDate).toFixed(0);
        this.date.startDate = startDate;
      }
      if (this.endDate != null && this.endDate != "") {
        let d = this.endDate; //开始时间
        let endDate = new Date(d).getTime() / 1000;
        endDate = Number(endDate).toFixed(0);
        this.date.endDate = endDate;
      }
    },
    //导出
    excelPost(){
      if(this.year == ''){
        this.$Message.error('年份不能为空');
        return false;
      }
      this.dates();
      this.loading = true;
      this.$myhttp.get('admin/MeterMultipleExcel/excel?year='+this.year,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
          this.loading = false;
          let data = backdata.data;
          if(data.code == 201){
            this.$Message.error(data.message);
          }
          if(data.code == 200){
            var login = window.localStorage.getItem('login');
            var token = window.localStorage.getItem('token');
            let url = imgurl+data.data+'?'+"&login_name="+login+"&token="+token;
            window.open(url, '_blank');
            this.$Message.success(data.message);
          }
      });
    },
    //上传
    //超过一个文件
    handleExceed(files, fileList) {
      // this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      this.$message.warning(`一次只允许上传1个文件`);
    },
    //删除
    beforeRemove(file, fileList) {
      this.tableData = [];
      this.total = 0;
      this.money = 0;
      return this.$confirm(`确定移除 ${ file.name }？`);
    },
    //限制大小
    beforeAvatarUpload(file){
      const isLt7M = file.size / 1024 / 1024 < 15;
      if (!isLt7M) {
        this.$message.error('上传文件大小不能超过 8MB!');
      }
      return isLt7M;
    },
    //上传成功返回
    handleAvatarSuccess(res, file){
      this.form.url = file.response[0];
      //console.log(369369);
      this.selects(1);
    },
    //下载
    download(url){
      var login = window.localStorage.getItem('login');
      var token = window.localStorage.getItem('token');
      // window.location.href = imgurl+'/'+url+'?'+"&login_name="+login+"&token="+token;
      let urls = imgurl+'/'+url+'?'+"&login_name="+login+"&token="+token;
      window.open(urls, '_blank');
    },
    //弹窗不要关闭
    loadingModals(){
      let _this = this;
      _this.loadingModal=false;
      setTimeout(() => {
        _this.loadingModal = true;
      }, 10);
    }
  },
  watch:{

  },
}
</script>
<style scoped>
.ti{
  margin: 1%;
  width: 98%;
}
.text1{
  text-align: center;
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search{
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2{
  color: rgb(250, 248, 248);
}
.kuan{
  width: 10%;
}
.zhanwu{
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.cdj_margin{
  margin-left:1px;
}
.d-flex {
    display: flex;
  }

  .d-flex-left {
    margin-right: 10px;
    border-right: 1px solid #eee;
    padding-right: 10px;
  }

  .d-flex-right {
    flex: 1;
  }

  .demo-spin-icon-load{
      animation: ani-demo-spin 1s linear infinite;
  }
  @keyframes ani-demo-spin {
      from { transform: rotate(0deg);}
      50%  { transform: rotate(180deg);}
      to   { transform: rotate(360deg);}
  }
  .demo-spin-col{
      height: 100px;
      position: relative;
  }
  .loading{
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 90%;
    width: 85%;
  }
  .d-flex {
    display: flex;
  }
  .d-flex-left {
    margin-right: 10px;
    border-right: 1px solid #eee;
    padding-right: 10px;
  }
  .d-flex-right {
    flex: 1;
    overflow-x:hidden;
  }
  .text2{
    color: rgb(250, 248, 248);
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/Project/MeterMultipleExcel.vue